import React, { FC, useState } from "react"
import { useEnterKeyPress } from "resha"
import { Box, Checkbox, MultiLineTextInput } from "dash-styled"
import { ReactComponent as SendIcon } from "icons/lib/send.svg"
import { ReactComponent as IconSpinner } from "icons/lib/spinner.svg"

interface SendMessageProps {
    onSend: (message: string) => Promise<void>
}

export const SendMessage: FC<SendMessageProps> = ({ onSend }) => {
    const [message, setMessage] = useState("")
    const [sending, setSending] = useState(false)
    const onMessageChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMessage(event.target.value)
    }

    const onClick = async () => {
        setSending(true)
        const result = await onSend(message.trim())
        if (result !== undefined) {
            setMessage("")
        }
        setSending(false)
    }

    useEnterKeyPress(onClick, !message || sending, "textarea")
    return (
        <Box
            fullWidth={true}
            display="flex"
            flexDirection="column"
            className="rounded border border-solid border-smoke-950 mb-3"
            testId="send-message"
        >
            <div
                className="w-full border-b border-solid border-smoke-600"
                style={{ minHeight: 36 }}
            >
                <MultiLineTextInput
                    className="h-auto text-rhino-620"
                    variant="transparent"
                    newlineExpanding={true}
                    size="sm"
                    inputProps={{
                        value: message,
                        onChange: onMessageChange,
                        placeholder: "Add a note for yourself",
                        readOnly: sending
                    }}
                    testId="feedback-message-input"
                />
            </div>
            <div className="w-full flex justify-between px-2 py-0.5 items-center">
                <Checkbox
                    variant="modern"
                    label={"Send to all labellers"}
                    isChecked={false}
                    className="text-xs px-1 invisible"
                />
                <button
                    onClick={onClick}
                    disabled={!message || sending}
                    data-testid="send-message-button"
                    className="pl-2 text-sm my-1 outline-none"
                >
                    {sending ? (
                        <IconSpinner className="w-4 h-4" />
                    ) : (
                        <SendIcon
                            className={
                                message ? "text-grape-100" : "text-smoke-800"
                            }
                        />
                    )}
                </button>
            </div>
        </Box>
    )
}
